import loadPostsLogic from "./loadPostsLogic";
import loadPostsFailLogic from "./loadPostsFailLogic";

export default [...loadPostsLogic, ...loadPostsFailLogic];
